//* Importing the necessary modules
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useApplications } from "../../../hooks/applications/useApplications";

//! Importing QRCode from react-qr-code
import QRCode from "react-qr-code";

//? Importing the CSS file
import "./CartaoResposta.css";
import { RiArrowGoBackLine } from "react-icons/ri";


//todo importing the loading component
import { Loading } from "../../../component/common/Loading";
import DefaultButton from "../../../component/base/DefaultButton";
import CandidateForm from "../printingDiagram/components/CandidateForm";

type CandidateFields = {
  diagramId: string;
  testId?: string;
  ansWerSheetId?: string;
  nameCandidate?: string;
  contestTitle: string;
  contestSubtitle: string;
  noticeLabel: string;
  positionLabel: string;
  positionName: string;
  locationLabel: string;
  locationName: string;
  cityLabel: string;
  cityName: string;
  roomLabel: string;
  room: string;
  numberControlLabel: string;
  numberControl: string;
  personType: string;
}

export function AnswerSheets({ editMode }: { editMode?: boolean }) {
  const {
    testId,
    diagramId,
    answerSheetId,
    registrationId,
    studentId,
    edit,
    urltoken,
  } = useParams<{
    testId?: string;
    diagramId?: string;
    answerSheetId?: string;
    registrationId?: string;
    studentId?: string;
    edit?: string;
    urltoken?: string;
  }>();

  // Se token não estiver no localStorage, pega da URL
  let token: string | null = localStorage.getItem("token") || urltoken || "";

  console.log("AnswerSheets - answerSheetId:", answerSheetId);
  console.log("AnswerSheets - testId:", testId);

  const { getFullApplication } = useApplications(token || "");
  const [data, setData] = useState<any>(null);

  const [fields, setFields] = useState<CandidateFields>({
    diagramId: diagramId ?? "",
    ansWerSheetId: answerSheetId ?? "",
    testId: testId ?? "",
    nameCandidate: "Nome do Candidato",
    contestTitle: "Título do Concurso",
    contestSubtitle: "Subtítulo do Concurso",
    noticeLabel: "Edital:",
    positionLabel: "Cargo/Opção:",
    positionName: "Nome do Cargo",
    locationLabel: "Local Da Prova: / Endereço:",
    locationName: "Nome do Local",
    cityLabel: "Município da Prova:",
    cityName: "Nome da Cidade",
    roomLabel: "Sala:",
    room: "Nome da Sala",
    numberControlLabel: "Número de Controle",
    numberControl: "Número de Controle",
    personType: "Tipo de Pessoa",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getFullApplication(
          testId || "",
          diagramId || "",
          token || "",
          answerSheetId || "",
          studentId || ""
        );
        console.log("Dados do Full:", response);
        setData(response);

        if (response) {
          setFields({
            diagramId: response.diagram.id,
            ansWerSheetId: response.answerSheet.id,
            testId: testId || "", 
            nameCandidate: response.registration
              ? response.registration.student.name
              : "Nome do Candidato",
            contestTitle: response.answerSheet.contestTitle,
            contestSubtitle: response.answerSheet.contestSubtitle,
            noticeLabel: response.answerSheet.noticeLabel,
            positionLabel: response.answerSheet.positionLabel,
            positionName: response.answerSheet.positionName,
            locationLabel: response.answerSheet.locationLabel,
            locationName: response.answerSheet.locationName,
            cityLabel: response.answerSheet.cityLabel,
            cityName: response.answerSheet.cityName,
            roomLabel: response.answerSheet.roomLabel,
            room: response.registration?.team.name ?? "Nome da Sala",
            numberControlLabel: "Número de Controle",
            numberControl: response.answerSheet.numberControl,
            personType: response.answerSheet.personType,
          });
        }
      } catch (error: any) {
        console.error("Erro ao buscar aplicação completa:", error);
      }
    };

    fetchData();
  }, [getFullApplication, testId, diagramId, answerSheetId, studentId, token]);

  const qrCodeValue =
    studentId && registrationId
      ? `studentId=${studentId}&registrationId=${registrationId}&testId=${testId}&answerSheetId=${answerSheetId}&diagramId=${diagramId}`
      : "";

  if (!data) {
    return <Loading />;
  }

  const defaultTestData = {
    questionsCount: { count: 1 },
    questions: [
      {
        id: "question-1",
        statement: "Exemplo de questão",
        subQuestions: [
          {
            id: "sub_question_1",
            statement: "Escolha a alternativa correta:",
            maxAlternatives: 4,
            objectives: [
              { id: "opt1", order: 1, text: "Alternativa A", isCorrect: false },
              { id: "opt2", order: 2, text: "Alternativa B", isCorrect: false },
              { id: "opt3", order: 3, text: "Alternativa C", isCorrect: true },
              { id: "opt4", order: 4, text: "Alternativa D", isCorrect: false },
            ],
          },
        ],
      },
    ],
  };

  const testData = data.diagram?.test || defaultTestData;
  const totalQuestions = testData?.questionsCount?.count || 1;

  const chunkQuestions = (numQuestions: number, chunkSize: number) => {
    const columnsArray = [];
    let start = 1;
    while (start <= numQuestions) {
      const end = Math.min(start + chunkSize - 1, numQuestions);
      columnsArray.push({ start, end });
      start += chunkSize;
    }
    return columnsArray;
  };

  const columns = chunkQuestions(totalQuestions, 20);
  const alternativeLabels = ["A", "B", "C", "D", "E", "F", "G"];

  const renderQuestions = (start: number, end: number) => {
    const rows = [];
    for (let i = start; i <= end; i++) {
      const question = testData.questions[i - 1];
      const subQuestion = question?.subQuestions?.[0];
      const maxAlts = subQuestion?.maxAlternatives ?? 5;
      const choices = alternativeLabels.slice(0, maxAlts).map((label) => (
        <div key={`${i}-${label}`} className="bubbleItem">
          <div className="bubbleCircle"></div>
          <span className="bubbleLetter">{label}</span>
        </div>
      ));
      rows.push(
        <div key={i} className="gabarito-row">
          <div className="question-number">{i}</div>
          <div className="bubbles">{choices}</div>
        </div>
      );
    }
    return rows;
  };

  return (
    <div>
      {/* HEADER / TÍTULO - Hidden during print */}
      <div
        className="no-print"
        style={{
          backgroundColor: "#f5f5f5",
          padding: "1rem",
          borderRadius: "4px",
          marginBottom: "1rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h4 className="mt-0 header-title fs-4 text-dark">
          {editMode ? "Editar" : "Cadastro"} Folha-Resposta
        </h4>
        <DefaultButton
          bg="secondary"
          text="Voltar"
          icon={<RiArrowGoBackLine />}
          to={`/tests/view/${testId}?tab=3`}
        />
      </div>

      {/* Formulário do candidato - Hidden during print */}
      <div className="no-print">
        <CandidateForm
          fields={fields}
          setFields={setFields}
          editMode={editMode}
          testId={testId || ""}
          answerSheetId={answerSheetId}
          token={token}
        />
      </div>
      
      {/* Cartão-resposta */}
      <div className="cartao-container">
        <div className="cartao-header">
          <h5 className="bold" id="title">{fields.contestTitle}</h5>
          <h6>{fields.contestSubtitle}</h6>
          <h6 className="bold">{fields.noticeLabel}</h6>
        </div>

        <div className="cartao-section">
          <div className="cartao-item">
            <p className="label">{fields.positionLabel}</p>
            <p className="value">{fields.positionName}</p>
          </div>
          <div className="cartao-item">
            <p className="label">{fields.locationLabel}</p>
            <p className="value">{fields.locationName}</p>
          </div>
          <div className="cartao-grid">
            <div className="cartao-item">
              <p className="label">{fields.cityLabel}</p>
              <p className="value">{fields.cityName}</p>
            </div>
            <div className="cartao-item">
              <p className="label">{fields.roomLabel}</p>
              <p className="value">{fields.room}</p>
            </div>
            <div className="cartao-item">
              <p className="label">{fields.numberControlLabel}</p>
              <p className="value">{fields.numberControl}</p>
            </div>
          </div>
        </div>

        <div className="cartao-section">
          <h6>LEIA ATENTAMENTE AS INSTRUÇÕES</h6>
          <ol className="instructions">
            <li>
              Verifique se seus dados estão corretos. Em caso de erro, chame o
              fiscal.
            </li>
            <li>Assine seu cartão-resposta.</li>
            <li>Use apenas caneta azul ou preta de corpo transparente.</li>
            <li>
              Os quadros de respostas seguem colunas numeradas verticalmente.
            </li>
            <li>
              Marque conforme o exemplo abaixo. Respostas erradas podem não ser
              lidas.
            </li>
            <img src="/photos_of_the_boxes.PNG" alt="Exemplo" width={200} height={25} />
            <li>A marcação é definitiva. Não rasure.</li>
            <li>Respostas fora das margens podem não ser lidas.</li>
            <li>Não suje, dobre ou amasse o cartão-resposta.</li>
            <li>Não altere dados impressos. Dúvidas? Chame o fiscal.</li>
          </ol>
        </div>

        <div className="cartao-qr">
          <div className="cartao-qr-text">
            <p>
              <strong>"NÃO RASURE ESTE LOCAL"</strong>
            </p>
            <p>
              Área reservada ao QR Code para identificação do{" "}
              {fields.personType}.
            </p>
          </div>
          <div className="cartao-qr-arrow"></div>
          <div className="cartao-qr-image">
            <QRCode value={qrCodeValue} size={70} />
          </div>
        </div>

        <div className="cartao-candidato">
          <h6 className="title">ÁREA DO {fields.personType.toUpperCase()}</h6>
          <div className="cartao-item">
            <p className="label">Nome do {fields.personType}:</p>
            <p className="value">{fields.nameCandidate}</p>
          </div>
          <div className="cartao-grid">
            <div className="cartao-item">
              <p className="label">Assinatura do {fields.personType}</p>
            </div>
            <div className="cartao-item">
              <p className="label">N° de identidade</p>
            </div>
          </div>
        </div>

        <div className="gabarito-wrapper">
          <div className="corner-mark corner-top-left"></div>
          <div className="corner-mark corner-top-right"></div>
          <div className="corner-mark corner-bottom-left"></div>
          <div className="corner-mark corner-bottom-right"></div>

          <h4 className="title cartao-resposta-title" id="cartao-resposta">
            CARTÃO-RESPOSTA
          </h4>

          <div className="gabarito-container">
            {columns.map((col, index) => (
              <div key={index} className="gabarito-column">
                <h4>
                  Respostas {col.start} a {col.end}
                </h4>
                {renderQuestions(col.start, col.end)}
              </div>
            ))}
          </div>
        </div>
      </div>
      
      {/* Add print styles */}
      <style dangerouslySetInnerHTML={{
        __html: `
          @media print {
            .no-print {
              display: none !important;
            }
          }
        `
      }} />
    </div>
  );
}
